module.exports = __webpack_public_path__ + "img/ios-more-facebook.d4a990c2.svg";